export const SwiperArrow = `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="12" fill="none">
    <path stroke="currentColor" strokeLinecap="round" d="M.499 6H12.5"/>
    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M7.949 1.05 12.899 6l-4.95 4.95"/>
  </svg>`;